module.exports = __webpack_public_path__ + "static/img/pp_logo.a7f1a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pp_logo.png
// module id = iPC7
// module chunks = 1